<ckeditor
    [editor]="Editor"
    [config]="editorConfig"
    [ngModel]="value"
    (ngModelChange)="writeValue($event)"
    [required]="required"
></ckeditor>
